import React from 'react';
import GradientIcon from './GradientIcon';

const PageHeader = ({ Icon, title, subtitle, size = 'md' }) => {
  const sizes = {
    sm: {
      icon: 'sm',
      title: 'text-2xl',
      subtitle: 'text-base'
    },
    md: {
      icon: 'md',
      title: 'text-3xl sm:text-4xl',
      subtitle: 'text-lg sm:text-xl'
    },
    lg: {
      icon: 'lg',
      title: 'text-5xl sm:text-6xl lg:text-7xl',
      subtitle: 'text-xl sm:text-2xl'
    }
  };

  const sizeClasses = sizes[size];

  return (
    <div className="text-center py-8 sm:py-12">
      {Icon && <GradientIcon Icon={Icon} size={sizeClasses.icon} className="mb-6" />}
      <h1 className={`${sizeClasses.title} font-extrabold text-gray-900 mb-4 leading-tight`}>
        {title}
      </h1>
      {subtitle && (
        <p className={`${sizeClasses.subtitle} text-gray-700 font-medium max-w-3xl mx-auto`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default PageHeader;
